import React from 'react';

const DataLine = ({ label, data, id }) => {
  return (
    <>
      <label htmlFor={id} className="form-label">
        {label}:
      </label>
      <input
        type="text"
        id={id}
        name={id}
        value={data}
        readOnly
        className="input-field"
      />
    </>
  );
};

export default DataLine;